export const DEFAULT_FALSY_VALUES = ['', 'null', 'undefined'];
/** Remove any non-string params and deduplicate them.
 * Also filter out any falsy values from the resulting array.
 *
 * Default falsy string values: `['', 'null', 'undefined']`  */
export const deduplicateAndFilterStringParams = (
  params: unknown[],
  falsyValues: string[] = ['', 'null', 'undefined'],
): string[] => {
  const stringsOnly = [...new Set(params)].filter(
    (entry) => typeof entry === 'string',
  );

  return stringsOnly.filter((entry) => {
    if (falsyValues.includes(entry)) return false;
    return true;
  });
};
